import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "w-full"
};
const _hoisted_2 = {
  class: "flex justify-between"
};
const _hoisted_3 = {
  class: "w-full pt-1 text-sm flex items-center gap-1"
};
const _hoisted_4 = {
  class: "font-weight-bold"
};
import { onMounted, ref, nextTick, watch } from 'vue';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import { useTasksStore } from '@/services/useTasksStore';
import { useBlockBilling } from '@/composables/useBlockBilling';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import LlResizableTextarea from '@/components/LlResizableTextarea.vue';
import LlTooltip from '@/components/LlTooltip.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { storeToRefs } from 'pinia';
export default {
  __name: 'DescriptionInput',
  props: {
    form: {
      type: Object,
      required: false
    },
    snippetService: {
      type: Object,
      required: false
    },
    editEntryState: {
      type: Object,
      required: false
    },
    enableBlockBilling: {
      type: Boolean,
      default: true
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: true
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: ['hoursCalculated', 'descriptionEdited'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      handleError
    } = useSnackbarHandler();
    const {
      listTasks
    } = useTasksStore();
    const {
      setOriginalValues,
      handleDescriptionChangeWithIncrement
    } = useBlockBilling();
    const {
      companySettings
    } = storeToRefs(useCompanyStore());
    const props = __props;
    const emit = __emit;
    const tasks = ref([]);
    onMounted(async () => {
      try {
        const tasksList = await listTasks();
        tasks.value = tasksList?.map(task => {
          return {
            ...task,
            name: getTaskLabel(task),
            value: task.id
          };
        });
        props.snippetService?.addShortCodeHandler?.('timeentry-description', tasks.value);

        // Store original values when component mounts using the composable
        if (props.form) {
          setOriginalValues(props.form.description || '', props.form.hours || 0);
        }
      } catch (error) {
        handleError(error);
      }
    });
    const getTaskLabel = task => {
      let label = task.label;
      if (task.shortCode) label = `[${task.shortCode}] ${label}`;
      return label;
    };
    const insertSnippet = taskItem => {
      nextTick(() => {
        if (!taskItem || !taskItem.label) return;
        const {
          description
        } = props.form;
        if (description && description.length) {
          if (description[description.length - 1] !== ' ') {
            props.form.description += ' ';
          }
          props.form.description += taskItem.label;
        } else {
          props.form.description = taskItem.label;
        }

        // Calculate hours after updating description
        handleDescriptionChange();
      });
    };

    // Only emits descriptionEdited on user-initiated changes (not programmatic)
    const onUserDescriptionChange = () => {
      emit('descriptionEdited');
      handleDescriptionChange();
    };
    const handleDescriptionChange = () => {
      if (!props.enableBlockBilling) {
        return;
      }
      const {
        description,
        id
      } = props.form;
      const {
        lockCalculatingHoursFromDescription
      } = props.editEntryState || {};
      handleDescriptionChangeWithIncrement(description, id, lockCalculatingHoursFromDescription, hours => emit('hoursCalculated', hours), companySettings.value?.enforceRounding, companySettings.value?.timeEntryIncrement || 0.1);
    };
    watch(() => props.form?.description, (newDescription, oldDescription) => {
      if (newDescription !== oldDescription && newDescription) {
        handleDescriptionChange();
      }
    });
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_list_subheader = _resolveComponent("v-list-subheader");
      const _component_v_list_item_title = _resolveComponent("v-list-item-title");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_list = _resolveComponent("v-list");
      const _component_v_menu = _resolveComponent("v-menu");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[1] || (_cache[1] = _createElementVNode("label", {
        class: "text-sm"
      }, "Description ", -1)), _withDirectives(_createElementVNode("span", _hoisted_4, "*", 512), [[_vShow, __props.required]]), _createVNode(LlTooltip, {
        text: "Visible to clients on invoice",
        location: "top"
      }, {
        activator: _withCtx(() => [_createVNode(_component_v_icon, {
          icon: "mdi-help-circle",
          class: "ll-info",
          size: "small",
          color: "blue-light-4 pb-2"
        })]),
        _: 1
      })])]), _createVNode(LlResizableTextarea, {
        modelValue: __props.form.description,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => __props.form.description = $event),
        rows: 3,
        id: "timeentry-description",
        onChange: onUserDescriptionChange,
        "data-cy": 'time-description-textarea',
        placeholder: "Enter description..."
      }, {
        append: _withCtx(() => [_createVNode(_component_v_menu, null, {
          activator: _withCtx(({
            props
          }) => [_createVNode(LlTooltip, {
            text: "Snippets",
            location: "top"
          }, {
            activator: _withCtx(() => [_createVNode(LlSecondaryButton, _mergeProps(props, {
              size: "small",
              variant: "text",
              class: "dropdown-toggle-btn"
            }), {
              default: _withCtx(() => [_createVNode(_component_v_icon, {
                size: "16"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("mdi-chevron-down", -1)]))]),
                _: 1
              })]),
              _: 1
            }, 16)]),
            _: 2
          }, 1024)]),
          default: _withCtx(() => [_createVNode(_component_v_list, {
            density: "compact",
            "max-width": "300",
            "max-height": "250"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_list_subheader, null, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("Snippets", -1)]))]),
              _: 1
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tasks.value, taskItem => {
              return _openBlock(), _createBlock(_component_v_list_item, {
                key: taskItem.value,
                onClick: $event => insertSnippet(taskItem)
              }, {
                default: _withCtx(() => [_createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(taskItem.name), 1)]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1032, ["onClick"]);
            }), 128)), tasks.value.length === 0 ? (_openBlock(), _createBlock(_component_v_list_item, {
              key: 0
            }, {
              default: _withCtx(() => [_createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("No snippets available", -1)]))]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};